/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import { Colors } from 'src/design-system/style-types';

import { Card } from '../Card';
import { DefaultProps as CardDefaultProps, defaultProps as cardDefaultProps } from '../Card/Card/Card';
import { style } from './ServerStatusCard.style';

interface RequiredProps {
  children: React.ReactNode;
}

type DefaultProps = CardDefaultProps & {
  borderTopColor?: Colors;
};

export type Props = RequiredProps & DefaultProps;

const defaultProps: DefaultProps = cardDefaultProps;

export const ServerStatusCard = (props: Props) => {
  const { children } = props;

  return (
    <Card {...props} css={style.container(props)}>
      <div css={style.inner(props)}>{children}</div>
    </Card>
  );
};

ServerStatusCard.defaultProps = defaultProps;
